import React from 'react';
import { useNotify } from '../../context/NotificationContext';

const ICONS = {
  success: '✓',
  error:   '!',
  warn:    '!',
  info:    'i'
};

const Notification = () => {
  const { toasts, remove } = useNotify();
  if (!toasts || !toasts.length) return null;

  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast toast-${t.level} ${t.leaving ? 'toast-leave' : ''}`}
          role="alert"
        >
          <div className="toast-icon">{ICONS[t.level] || 'i'}</div>
          <div className="toast-body">
            {t.title && <div className="toast-title">{t.title}</div>}
            {t.message && <div className="toast-msg">{t.message}</div>}
          </div>
          <button className="toast-close" onClick={() => remove(t.id)}>×</button>
          <div className="toast-progress" />
        </div>
      ))}
    </div>
  );
};

export default Notification;
